import styled from 'styled-components';
import {
  Popover, Button, Divider, Col, Row, Spin,
  Tabs,
  Checkbox,
} from 'antd';
import { CaretDownOutlined } from '@ant-design/icons';
import {
  primaryColor,
  primaryFont, primaryHeadingColor, secondaryFont,
  wMedium, maxWidth, retina, driver, maxTablet, scrollbar,
  greyColor,
} from 'Utils/utilsStyle';
// svgs
import { Filter } from 'Types/FilterTypes';
import classNames from 'classnames';
import { Params, useLocation, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
  allValueInKeyOfArrayExists, certificationSmoothBehavior, smoothBehavior,
} from 'Utils/UtilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { actions as certificationActions } from 'Slice/CertificationSlice';
import { selectData } from 'Selector/CertificationSelector';
import { FEED_NEWS_ROUTE } from 'Utils/Constants';
// import FilterDarkIcon from '../assets/svgIcons/FilterDarkIcon';
// import FilterIcon from '../assets/svgIcons/FilterIcon';

import AlertsTriggersCheckBox from '../../alerts/components/AlertsTriggersCheckBox';
import FilterIcon from '../../common/assets/svgIcons/FilterIcon';
import FilterDarkIcon from '../../common/assets/svgIcons/FilterDarkIcon';
import FeedLoadingSkeleton from '../../common/skeleton/FeedFilterSkeleton';
import { SelectedCompany } from '../../../Types/ClustersTypes';
// import FeedLoadingSkeleton from '../skeleton/FeedFilterSkeleton';

const Wrapper = styled.div`
 .active{
    background: #DEF6E6 !important;
    color: #09A43A;
    svg{
      g{
        fill: #09A43A;
      }
    }
 }
`;
const ContentWrapper = styled.div`
  h2 {
    font-size: 28px;
    color: ${primaryHeadingColor};
    font-weight: 800;
    font-family: ${secondaryFont};
    letter-spacing: -0.45px;
    line-height: 1.111 !important;
    margin-bottom: 0px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 20px;
    }
  }
  svg{
     @media all and (max-width: ${maxWidth}) , ${retina} {
      max-width: 22px;
    }
  }
  p {
    font-size: 16px;
    color: #7E7E7E !important;
    font-weight: ${wMedium};
    font-family: ${primaryFont};
    letter-spacing: -0.4px;
    margin: 0;
  }
  .upperPart{
    padding: 20px 23px 0 23px;
     @media all and (max-width: ${maxWidth}) , ${retina} {
      padding: 20px 16px 0 16px;
    }
    .no_filter{
      color: ${driver} !important;
      text-align: center;
      margin: 10px 0 -10px 0;
    }
  }
  .lowerPart{
    padding: 0 47px 20px 23px;
     @media all and (max-width: ${maxWidth}) , ${retina} {
      padding: 0 16px 20px 16px;
    }
  }
  .userInfoSection {
    margin-top: 18px;
  }
  .linksSection {
    margin-top: 24px;
    /* padding: 18px 18px 20px 18px; */
    background-color: #F8F8F8;
    border-radius: 0 0 20px 20px;
     @media all and (max-width: ${maxWidth}) , ${retina} {
      border-radius: 0 0 10px 10px;
    }
    .ant-tabs {
      .ant-tabs-nav {
        .ant-tabs-nav-list {
          width: 100%;
          .ant-tabs-tab {
            width: 50%;
            justify-content: center;
            .ant-tabs-tab-btn {
              width: 100%;
              text-align: center;
              border-radius: 0px !important;
            }
          }
          .ant-tabs-ink-bar {
            display: none;
          }
        }

      }
      .ant-tabs-content-holder {
        padding: 0px 18px 20px 18px;
        .ant-checkbox-wrapper {
          .ant-checkbox-label {
            color: ${greyColor};
            font-family: ${primaryFont};
            font-size: 16px;
            font-weight: ${wMedium};
            line-height: 16.495px;
            letter-spacing: -0.33px;
          }
        }
      }
    }
    .heading-panel{
      button{
        @media all and (max-width: ${maxWidth}) , ${retina} {
          font-size:12px;
          padding: 0;
        }
      }
      h6.head{
        @media all and (max-width: ${maxWidth}) , ${retina} {
          font-size:12px;
        }
      }
    }
    .grid-checkbox-wrapper {
      @media all and (max-width: 1400px) {
        max-height: 310px;
        ${scrollbar};
      }
      @media all and (max-height: 650px) {
        max-height: 210px;
      }
    }
  }
  .linkMarginTop {
    padding-top: 18px;
  }
  .filter-btn {
    display: inline-block;
    border-radius: 8px;
    background-color: ${primaryColor};
    color: #fff;
    font-family: Roboto;
    font-weight: 900;
    font-size: 14px;
    line-height: 14px;
    cursor: pointer;
    text-align: center;
    margin-bottom: 0px;
    &:hover {
      border-color: ${primaryColor} !important;
      background-color: transparent !important;
      color: ${primaryColor} !important;
    }
  }
  .disabled-btn {
    opacity: 0.7;
    pointer-events: none;
  }
`;

const LoadingWrapper = styled.div`
  &.iconModeActive {
    .ant-spin-spinning {
      margin-top: 8px;
    }
  }
  height: 38px;
  @media all and (max-width: ${maxTablet}) {
   height: auto; 
  }
  .ant-spin-spinning {
   margin-top: 2px;
  }
`;

type Props = {
  onlyIcon?: boolean,
  loading?: boolean,
  filters: Filter[],
  selectAll?: boolean,
  iconMode?: boolean,
  iconForBtn?: object,
  isActive?: boolean,
  onChangeFilters?: (flag: boolean, id: string) => void,
  onChangeCompanies?: (companyId: number) => void,
  onClickHandler?: () => void,
  applyFilterHandler?: () => void,
  disableApplyBtn?: boolean,
  salesTriggerPopup?: boolean,
  buttonTitle?: string,
  showContent?: boolean,
  selectedCompanies: SelectedCompany[],
  selectedCompaniesId: number[],
} & typeof defaultProps;

const defaultProps = {
  onlyIcon: true,
  loading: false,
  selectAll: false,
  iconMode: false,
  isActive: false,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChangeFilters: (a: true, id: '0') => { },
  onChangeCompanies: (id: 0) => { },
  onClickHandler: () => { },
  applyFilterHandler: () => { },
  disableApplyBtn: false,
  salesTriggerPopup: false,
  iconForBtn: <FilterIcon />,
  buttonTitle: 'Filter',
  showContent: true,
  selectedCompanies: [],
  selectedCompaniesId: [],
};

const ClusterFilterPopover = function ClusterFilterPopover({
  onlyIcon,
  loading,
  filters,
  selectAll,
  iconMode,
  onChangeFilters,
  onClickHandler,
  applyFilterHandler,
  disableApplyBtn,
  isActive,
  salesTriggerPopup,
  iconForBtn,
  buttonTitle,
  showContent,
  selectedCompanies,
  selectedCompaniesId,
  onChangeCompanies,
}: Props) {
  const { section } = useParams<Params>();
  const [isNoFilterSelected, setIsNoFilterSelected] = useState<boolean>(false);
  const [isNoCompanySelected, setIsNoCompanySelected] = useState<boolean>(false);
  const [showFilterError, setShowFilterError] = useState(false);
  const [showCompanyError, setShowCompanyError] = useState(false);
  const [activeTab, setActiveTab] = useState<string>('');

  useEffect(() => {
    setIsNoFilterSelected(allValueInKeyOfArrayExists(filters, 'isSelected', false));
  }, [filters]);

  useEffect(() => {
    const hasSelectedCompanies = selectedCompaniesId.length > 0
    setIsNoCompanySelected(!hasSelectedCompanies)
  }, [selectedCompaniesId]);

  const applyData = () => {
    applyFilterHandler();
    if (salesTriggerPopup) {
      certificationSmoothBehavior('sales_triggers');
    } else {
      smoothBehavior();
    }
  };

  const data = useSelector(selectData);
  const dispatch = useDispatch();
  const [applyClicked, setApplyClicked] = useState(false);

  const { pathname } = useLocation();

  const handleClick = () => {
    setApplyClicked(true);
    applyData();
  };

  useEffect(() => {
    if (applyClicked) {
      setApplyClicked(false);
    }
  }, [applyClicked]);

  const content = (
    <ContentWrapper>
      <div className="upperPart">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <FilterDarkIcon />
            <h2 className="primary-color text-center ml-1">
              Filter
            </h2>
          </div>
          <div className="d-flex align-items-center">
            <Button
              onClick={handleClick}
              className={`filter-btn ${(disableApplyBtn || isNoFilterSelected || isNoCompanySelected) ? 'disabled-btn' : ''}`}
              aria-label="Profile picture for menu"
            >
              Apply

            </Button>
          </div>
        </div>
        {(isNoFilterSelected && activeTab === "filters") && <p className="no_filter">Please Select One Filter at Least</p>}
        {
          (isNoCompanySelected && activeTab === "companies") && <p className="no_filter">Please Select One Company at Least</p>
        }
      </div>
      <div className="linksSection">
        <Tabs onChange={(key) => setActiveTab(key)}>
          <Tabs.TabPane
            tab="xiQ Sales Triggers"
            key="filters"
          >
            <div className="heading-panel">
              <h6 className="head">xiQ Sales Trigger:</h6>
              <span className="unselect" onClick={onClickHandler} onKeyPress={onClickHandler} tabIndex={0} role="button" aria-label="unselect all">{selectAll ? 'unselect all' : 'select all'}</span>
            </div>
            <div className="grid-checkbox-wrapper">
              <Row>
                {loading || applyClicked ? (
                  <FeedLoadingSkeleton />
                )
                  : (
                    <>
                      <Col span={12}>
                        {filters.slice(0, Math.ceil((filters.length / 2))).map(
                          (item) => (
                            <AlertsTriggersCheckBox
                              key={item.filterId}
                              title={item.filterName}
                              color={item.filterColor}
                              checked={item.isSelected}
                              onCheckedChange={onChangeFilters}
                              id={item.filterId}
                            />
                          ),
                        )}
                      </Col>
                      <Col span={12}>
                        {filters.slice(Math.ceil((filters.length) / 2), filters.length).map(
                          (item) => (
                            <AlertsTriggersCheckBox
                              key={item.filterId}
                              title={item.filterName}
                              color={item.filterColor}
                              checked={item.isSelected}
                              onCheckedChange={onChangeFilters}
                              id={item.filterId}
                            />
                          ),
                        )}
                      </Col>
                    </>
                  )}
              </Row>
            </div>
          </Tabs.TabPane>
          <Tabs.TabPane
            tab="Companies"
            key="companies"
          >
            {
              selectedCompanies.map((company) => (
                <Checkbox
                  key={company.companyId}
                  checked={selectedCompaniesId.includes(company.companyId)}
                  onChange={() => onChangeCompanies(company.companyId)}
                >
                  {company.companyName}
                </Checkbox>
              ))
            }
          </Tabs.TabPane>
        </Tabs>
      </div>
    </ContentWrapper>
  );

  return (
    loading || applyClicked
      ? (
        <LoadingWrapper className={classNames('tabs-wrapper justify-content-end loading-tab', { iconModeActive: iconMode })}>
          <div className="tabs-item spin-tablet">
            <Spin />
          </div>
        </LoadingWrapper>
      )
      : (
        <Wrapper>
          {showContent
            ? (
              <Popover
                overlayClassName="global-filter cluster-filter"
                placement="bottomRight"
                content={content}
                overlayInnerStyle={{
                  borderRadius: '20px',
                  padding: '0px',
                }}
                trigger="click"
                // getPopupContainer={(e: HTMLElement) => e}
                getPopupContainer={() => document.body}
                arrow={false}
                align={{ offset: [0, 0] }}
                autoAdjustOverflow={false}
              >
                <div className={classNames(
                  'tabs-wrapper justify-content-end resolution-filter-popover',
                  { iconModeActive: iconMode },
                )}
                >
                  <Button
                    className={classNames(
                      'tabs-item d-flex justify-content-center align-items-center global-tabs-item',
                      { active: isActive },
                    )}
                    aria-label="Filter Icon"
                  >
                    {iconForBtn}
                    {
                      onlyIcon ? (
                        <>
                          <span
                            className="filter-text"
                            style={{
                              marginLeft: '10px',
                              marginRight: '8px',
                            }}
                          >
                            {buttonTitle}
                          </span>
                          <Divider type="vertical" />
                          <CaretDownOutlined />
                        </>
                      ) : null
                    }
                  </Button>
                </div>
              </Popover>
            )
            : (
              <div className={classNames(
                'tabs-wrapper justify-content-end resolution-filter-popover',
                { iconModeActive: iconMode },
              )}
              >
                <Button
                  className={classNames(
                    'tabs-item d-flex justify-content-center align-items-center global-tabs-item',
                    { active: isActive },
                  )}
                  aria-label="Filter Icon"
                >
                  {iconForBtn}
                  {
                    onlyIcon ? (
                      <>
                        <span
                          className="filter-text"
                          style={{
                            marginLeft: '10px',
                            marginRight: '8px',
                          }}
                        >
                          {buttonTitle}
                        </span>
                        <Divider type="vertical" />
                        <CaretDownOutlined />
                      </>
                    ) : null
                  }
                </Button>
              </div>
            )}
        </Wrapper>
      )
  );
};

ClusterFilterPopover.defaultProps = defaultProps;
export default ClusterFilterPopover;